module.exports = __webpack_public_path__ + "img/_voice_off.15d3c3ad.svg";